<app-key-value-table [keyValues]="keyValues"></app-key-value-table>
